export default "__VITE_ASSET__83afec07__"